module Meevo.Components.Modal {

    export enum ModalTypeEnum {
        Alert,
        Confirm,
        Error,
        Warning,
        OkCancel,
        Note,
        Message,
        NoteRegister,
        OBConfirm,
        Info
    }

    export enum ModalTranslationModes {
        Translate,
        DoNotTranslate,
        AsHtml
    }

}
